var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"urlInfo"},[(_vm.data.length > 0)?_c('div',{staticClass:"img-box"},_vm._l((_vm.data),function(img){return _c('div',{key:img,staticClass:"img"},[_c('el-image',{staticStyle:{"width":"100px","height":"100px","border":"1px solid #dddddd","margin":"5px"},attrs:{"src":img,"preview-src-list":_vm.data}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }